import React, { Component } from 'react';
import './Emails.css';
import axios from 'axios';
import EmailCard from '../EmailCard/EmailCard';
import { BASE_HOST_URL } from '../../config';

class Emails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: []
    };
  }

  async componentDidMount() {
    try {
      const { data } = await axios.get(`${BASE_HOST_URL}/api/v1/email`);
      //const { data } = await axios.get('http://localhost:3005/api/v1/email');
      this.setState({ emails: data });
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <div className="emailsWrapper">
        <h4>Bandeja de entrada</h4>
        {this.state.emails.map((email, index) => (
          <EmailCard key={index} fullName={email.fullName} message={email.message} email={email.email} createdAt={email.createdAt} />
        ))}
      </div>
    );
  }
}

export default Emails;



// WEBPACK FOOTER //
// ./src/components/Emails/Emails.js